import type {
  CommissionResponse,
  WithdrawSuccessResponse,
} from '@/shared/types';
import { apiClient, handleRequest } from '@/shared/api';
import type {
  CardCheckCreateBody,
  CardCheckCreateResponse,
  WithdrawCardRequestFunction,
} from '@/features/withdraw-card';

export const checkAndCreateCard = async (
  body: CardCheckCreateBody
): Promise<CardCheckCreateResponse> => {
  const request = () => apiClient.post('/operations/card', body);
  const response = await handleRequest<CardCheckCreateResponse>(request);

  return response.data;
};

export const getWithdrawCommission = async (
  currencyCode: string,
  amount: string | number,
  onTop?: boolean
): Promise<CommissionResponse> => {
  const response = await apiClient.get<CommissionResponse>(
    `/operations/card/withdraw/commission`,
    {
      params: {
        currencyCode,
        amount,
        ontop: onTop,
      },
    }
  );
  return response.data;
};

export const withdrawCard: WithdrawCardRequestFunction = async body => {
  const response = await apiClient.post<WithdrawSuccessResponse>(
    `/operations/card/withdraw`,
    body
  );
  return response.data;
};
